import { useEffect } from 'react';
import { useStoreHostnameStore } from '../../stores/useStoreHostnameStore';
import { useStoreInfoStore } from '../../stores/useStoreInfoStore';
import { useChatContext } from '../context/use-chat-context';

export function useGetStoreInfo() {
  const { isSuperserveUi, isPlayground } = useChatContext();
  const getHostname = useStoreHostnameStore((state) => state.getHostname);
  const customHostname = useStoreHostnameStore((state) => state.customHostname);

  const store = useStoreInfoStore((s) => s.store);
  const currentSession = useStoreInfoStore((s) => s.currentSession);
  const storeSettings = useStoreInfoStore((s) => s.storeSettings);
  const isLoading = useStoreInfoStore((s) => s.isLoading);
  const error = useStoreInfoStore((s) => s.error);
  const fetchStoreInfo = useStoreInfoStore((s) => s.fetchStoreInfo);

  useEffect(() => {
    // For superserveUI, wait until customHostname is set
    if (isSuperserveUi && !customHostname) {
      return;
    }

    const hostname = getHostname();
    fetchStoreInfo(hostname, { isPlayground });
  }, [
    getHostname,
    customHostname,
    isSuperserveUi,
    isPlayground,
    fetchStoreInfo,
  ]);

  return {
    currentSession,
    store,
    storeSettings,
    isLoading,
    error,
  };
}
